module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aaa4a3575852fe11d04f44c4a972ae73.svg";